import styled from "styled-components";
import { useRef } from "react";
import { CalendarDays } from "lucide-react";

import { theme } from "./theme";
import { formatDate } from "./dateFormat";
import { useT } from "./i18n";

// A single labelled date field that matches the Beranda date control (DateNav's DateButton): a calendar
// icon + the formatted date, backed by the native date picker. Nullable — shows the placeholder when
// empty. Used for the shift-notes from/to range so both pages share one look.
const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 0.72rem;
  font-weight: 700;
  color: ${theme.muted};
`;

const Button = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  min-width: 160px;
  justify-content: flex-start;
  padding: 0.4rem 0.8rem;
  border: 1px solid ${theme.border};
  border-radius: 8px;
  background: #ffffff;
  font-size: 0.9rem;
  font-weight: 600;
  color: ${(props) => (props.$empty ? theme.muted : theme.ink)};
  cursor: pointer;
  &:hover {
    border-color: ${theme.gold};
  }
`;

// Present (so showPicker works) but invisible and non-interactive; the button drives it.
const HiddenInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
`;

const DatePickField = (props) => {
  const { lang } = useT();
  const inputRef = useRef(null);

  const openPicker = () => {
    const el = inputRef.current;
    if (el && typeof el.showPicker === "function") {
      el.showPicker();
    } else if (el) {
      el.focus();
    }
  };

  return (
    <Field>
      {props.label}
      <Button type="button" $empty={!props.value} onClick={openPicker}>
        <CalendarDays size={15} />
        {props.value ? formatDate(props.value, lang) : props.placeholder || "—"}
        <HiddenInput
          ref={inputRef}
          type="date"
          value={props.value || ""}
          min={props.min || undefined}
          max={props.max || undefined}
          onChange={(event) => props.onChange(event.target.value)}
        />
      </Button>
    </Field>
  );
};

export default DatePickField;
